import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import ar from "../../locale";
import { title } from "../../constants";
import VideosReviewed from "./videoReviewed";

export default class MyHobby extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    document.title = title + " - " + ar.my_hobby;
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  render() {
    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6">
              <VideosReviewed reviewed={true} {...this.props} />
            </div>
            <div className="col-lg-6">
              <VideosReviewed reviewed={false} {...this.props} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
